import React, { useState } from "react"
import { motion } from "framer-motion"
import { useStaticQuery, graphql } from "gatsby"
import style from "../components/resultaatMobile.module.scss"
import KijkItemMobile from "./kijkItemMobile"
import LuisterItemMobile from "./luisterItemMobile"

import eye from "../assets/svg/icon_eye.svg"
import ear from "../assets/svg/icon_ear.svg"
import book from "../assets/svg/icon_book.svg"
import LeesItemMobile from "./leesItemMobile"

export default function ResultaatMobile() {
  const data = useStaticQuery(
    graphql`
      query MyMobileResultFotos {
        allFile(
          filter: { relativeDirectory: { glob: "archief/*" } }
          sort: { fields: name, order: DESC }
        ) {
          edges {
            node {
              id
              name
              childImageSharp {
                gatsbyImageData(
                  height: 900
                  placeholder: NONE
                  formats: [AUTO, WEBP, AVIF]
                )
              }
              relativeDirectory
            }
          }
        }
      }
    `
  )

  const [mediaType, setMediaType] = useState("kijk")
  const fotos = data.allFile.edges

  const arash = fotos.map(
    foto => foto.node.relativeDirectory.startsWith("archief/Arash") && foto.node
  )
  const bart = fotos.map(
    foto => foto.node.relativeDirectory.startsWith("archief/Bart") && foto.node
  )
  const hester = fotos.map(
    foto =>
      foto.node.relativeDirectory.startsWith("archief/Hester") && foto.node
  )
  const marijke = fotos.map(
    foto =>
      foto.node.relativeDirectory.startsWith("archief/Mareike") && foto.node
  )
  const maria = fotos.map(
    foto => foto.node.relativeDirectory.startsWith("archief/Maria") && foto.node
  )
  const pj = fotos.map(
    foto => foto.node.relativeDirectory.startsWith("archief/PJ") && foto.node
  )
  const roy = fotos.map(
    foto => foto.node.relativeDirectory.startsWith("archief/roy") && foto.node
  )
  const groep = fotos.map(
    foto => foto.node.relativeDirectory.startsWith("archief/groep") && foto.node
  )

  const media = {
    arash: {
      beeld: arash,
      geluid: "https://soundcloud.com/user-657870329/arash-fakhim",
      info: {
        voornaam: `Arash`,
        achternaam: `Fakhim`,
        locatie: `Schwitzner`,
        link: false,
        programmaType: `WEEF STAD`,
      },
    },
    bart: {
      beeld: bart,
      geluid: "https://soundcloud.com/user-657870329/bart-lunenburg",
      info: {
        voornaam: `Bart`,
        achternaam: `Lunenburg`,
        locatie: `Marienhof`,
        link: false,
        programmaType: `WEEF STAD`,
      },
    },
    hester: {
      beeld: hester,
      geluid: "https://soundcloud.com/user-657870329/hester-haarsma",
      info: {
        voornaam: `Hester`,
        achternaam: `Haarsma`,
        locatie: `Marienhof`,
        link: false,
        programmaType: `WEEF STAD`,
      },
    },
    marijke: {
      beeld: marijke,
      geluid: "https://soundcloud.com/user-657870329/marijke-schurink",
      info: {
        voornaam: `Marijke`,
        achternaam: `Schurink`,
        locatie: `Onze Lieve Vrouwe toren`,
        link: false,
        programmaType: `WEEF STAD`,
      },
    },
    maria: {
      beeld: maria,
      geluid: false,
      info: {
        voornaam: `Maria`,
        achternaam: `Blaisse`,
        locatie: `Rietveldpaviljoen`,
        link: "https://vimeo.com/525657908",
        programmaType: `WEEF SOLO`,
      },
    },
    pj: {
      beeld: pj,
      geluid: "https://soundcloud.com/user-657870329/pj-roggeband",
      info: {
        voornaam: `PJ`,
        achternaam: `Roggeband`,
        locatie: `Amersfoortse Zwaan`,
        link: false,
        programmaType: `WEEF STAD`,
      },
    },
    roy: {
      beeld: roy,
      geluid: "https://soundcloud.com/user-657870329/roy-vastenburg",
      info: {
        voornaam: `Roy`,
        achternaam: `Vastenburg`,
        locatie: `De Drie Ringen`,
        link: `https://vimeo.com/528752826`,
        programmaType: `WEEF STAD`,
      },
    },
    groep: {
      beeld: groep,
      geluid: "https://soundcloud.com/user-657870329/marijke-schurink",
      info: {
        voornaam: `Groeps`,
        achternaam: `Expositie`,
        locatie: `Museum Flehite`,
        link: false,
        programmaType: `WEEF EXPO`,
      },
    },
    extra: {
      beeld: false,
      geluid:
        "https://soundcloud.com/user-657870329/weef-architectuurcafe-fasade",
      info: {
        voornaam: `FASadE`,
        achternaam: ``,
        locatie: `Architectuurcafe FASadE`,
        link: false,
        programmaType: `WEEF EXTRA`,
      },
    },
  }

  const leesLinks = [
    {
      naam: "Maria Blaisse bij WEEF!",
      link: `https://www.lucyindelucht.nl/te-zien/maria-blaisse-bij-weef!`,
    },
    {
      naam: "WEEF geschiedenis en losse draadjes",
      link: `https://www.lucyindelucht.nl/te-zien/weef-2-geschiedenis-en-losse-draadjes`,
    },
    {
      naam: "Schuilhut van wol",
      link: `https://www.lucyindelucht.nl/te-zien/weef-blog/schuilhut-van-wol`,
    },
    {
      naam: "De lappendeken van PJ Roggeband",
      link: `https://www.lucyindelucht.nl/te-zien/weef-blog/de-lappendeken-van-pj-roggeband`,
    },
    {
      naam: "Hester Haarsma - Ledigheid",
      link: `https://www.lucyindelucht.nl/te-zien/weef-blog/hester-haarsma-ledigheid`,
    },
    {
      naam: "Rebelse wandkleden",
      link: `https://www.lucyindelucht.nl/te-zien/weef-blog/rebelse-wandkleden`,
    },
  ]

  return (
    <motion.div
      className={style.wrapper}
      initial={{ opacity: 0, top: 800 }}
      animate={{ opacity: 1, top: 0 }}
      exit={{ opacity: 0, top: 800 }}
    >
      <div className={style.nav}>
        <div>
          <button onClick={() => setMediaType("kijk")}>
            <img src={eye} width={40} alt="kijk"></img>
          </button>
          <button onClick={() => setMediaType("luister")}>
            <img src={ear} width={40} alt="luister"></img>
          </button>
          <button onClick={() => setMediaType("lees")}>
            <img src={book} width={40} alt="lees"></img>
          </button>
        </div>
        {mediaType === "luister" && (
          <div className={style.podcastCredit}>
            <p>
              Podcasts:{" "}
              <a href={`https://corlijn.com/`} target="_blank" rel="noreferrer">
                Corlijn de Groot
              </a>
            </p>
          </div>
        )}
        {mediaType === "kijk" && (
          <div className={style.podcastCredit}>
            <p>
              Fotos:{" "}
              <a
                href={`https://www.jolanthelalkens.nl/`}
                target="_blank"
                rel="noreferrer"
              >
                Jolanthe Lakens
              </a>
            </p>
          </div>
        )}
      </div>
      {mediaType === "kijk" && (
        <div className={style.kijken}>
          <KijkItemMobile
            beeld={media.maria.beeld}
            info={media.maria.info}
            mediaType="beeld"
          ></KijkItemMobile>

          <KijkItemMobile
            beeld={media.arash.beeld}
            info={media.arash.info}
            mediaType="beeld"
          ></KijkItemMobile>
          <KijkItemMobile
            beeld={media.bart.beeld}
            info={media.bart.info}
            mediaType="beeld"
          ></KijkItemMobile>
          <KijkItemMobile
            beeld={media.hester.beeld}
            info={media.hester.info}
            mediaType="beeld"
          ></KijkItemMobile>
          <KijkItemMobile
            beeld={media.marijke.beeld}
            info={media.marijke.info}
            mediaType="beeld"
          ></KijkItemMobile>
          <KijkItemMobile
            beeld={media.pj.beeld}
            info={media.pj.info}
            mediaType="beeld"
          ></KijkItemMobile>
          <KijkItemMobile
            beeld={media.roy.beeld}
            info={media.roy.info}
            mediaType="beeld"
          ></KijkItemMobile>
          <KijkItemMobile
            beeld={media.groep.beeld}
            info={media.groep.info}
            mediaType="beeld"
          ></KijkItemMobile>
          <div className={style.filler}></div>
        </div>
      )}

      {mediaType === "luister" && (
        <div className={style.kijken}>
          <LuisterItemMobile
            geluid={media.arash.geluid}
            info={media.arash.info}
            mediaType="geluid"
          ></LuisterItemMobile>
          <LuisterItemMobile
            geluid={media.bart.geluid}
            info={media.bart.info}
            mediaType="geluid"
          ></LuisterItemMobile>
          <LuisterItemMobile
            geluid={media.hester.geluid}
            info={media.hester.info}
            mediaType="geluid"
          ></LuisterItemMobile>
          <LuisterItemMobile
            geluid={media.marijke.geluid}
            info={media.marijke.info}
            mediaType="geluid"
          ></LuisterItemMobile>
          <LuisterItemMobile
            geluid={media.pj.geluid}
            info={media.pj.info}
            mediaType="geluid"
          ></LuisterItemMobile>
          <LuisterItemMobile
            geluid={media.roy.geluid}
            info={media.roy.info}
            mediaType="geluid"
          ></LuisterItemMobile>
          <LuisterItemMobile
            geluid={media.extra.geluid}
            info={media.extra.info}
            mediaType="geluid"
          ></LuisterItemMobile>
          <div className={style.filler}></div>
        </div>
      )}
      {mediaType === "lees" && (
        <div className={style.kijken}>
          <LeesItemMobile
            info={media.arash.info}
            links={leesLinks}
          ></LeesItemMobile>
          <div className={style.filler}></div>
        </div>
      )}
    </motion.div>
  )
}
